import { extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import Badge from '../deprecated/badge/index.js';
import { useGeneratedId } from '../utils/index.js';
import { useFileDragDetector } from './hooks/useFileDragDetector.js';
import { useProgressWarning } from './hooks/useProgressWarning.js';
import { Container, Input, StickyContent, BadgeContainer, Label, Description } from './styled.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { themeGet } from '../v2/foundation/theme/themeGet/get.js';
import FileUploadGlyph from '../glyphs/generated/FileUploadGlyph.js';

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var Dropzone = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var controlledId = props.id,
    label = props.label,
    className = props.className,
    description = props.description,
    _props$progress = props.progress,
    progress = _props$progress === void 0 ? -1 : _props$progress,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    restProps = __rest(props, ["id", "label", "className", "description", "progress", "size"]);
  var _useFileDragDetector = useFileDragDetector(),
    isDragging = _useFileDragDetector.isDragging;
  var autoId = useGeneratedId('dropzone');
  var id = controlledId || autoId;
  var describedBy = description ? id + "-description" : undefined;
  var isLoading = progress >= 0 && progress <= 1;
  useProgressWarning(progress);
  return /*#__PURE__*/jsxs(Container, {
    className: className,
    $isDragging: isDragging,
    children: [/*#__PURE__*/jsx(Input, _extends({
      id: id,
      ref: forwardedRef,
      type: "file",
      "aria-describedby": describedBy,
      disabled: isLoading
    }, restProps)), /*#__PURE__*/jsxs(StickyContent, {
      $size: size,
      children: [/*#__PURE__*/jsx(BadgeContainer, {
        style: {
          background: "conic-gradient(" + themeGet('colors.blue.300') + " " + progress * 360 + "deg, transparent 0deg)"
        },
        children: /*#__PURE__*/jsx(Badge, {
          glyph: FileUploadGlyph,
          size: "large",
          appearance: "info"
        })
      }), label && /*#__PURE__*/jsx(Label, {
        htmlFor: id,
        children: label
      }), description && /*#__PURE__*/jsx(Description, {
        id: describedBy,
        $hide: isLoading,
        children: description
      })]
    })]
  });
});
Dropzone.displayName = 'Dropzone';
var Dropzone$1 = Dropzone;

export { Dropzone$1 as default };
